module.exports = __webpack_public_path__ + "img/bg.a4fd19d8.png";